module.exports = __webpack_public_path__ + "static/media/task_il_tg.69695ba9.svg";